import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { PurposeActions } from './purpose.actions';
import { IPurposeState } from './purpose.state';

export const initialPurposeState: IPurposeState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const purposeReducerFn = createReducer(
  initialPurposeState,
  on(PurposeActions.reset, (state: IPurposeState, action) => {
    return new StateBuilder<IPurposeState>(initialPurposeState).build();
  }),
  on(PurposeActions.load, (state: IPurposeState, action) => {
    return new StateBuilder<IPurposeState>(state).toLoading().build();
  }),
  on(PurposeActions.loadSuccess, (state: IPurposeState, action) => {
    return new StateBuilder<IPurposeState>(state, action).toLoaded().build();
  }),
  on(PurposeActions.submit, (state: IPurposeState, action) => {
    return new StateBuilder<IPurposeState>(state).toLoading().build();
  }),
  on(PurposeActions.submitSuccess, (state: IPurposeState, action) => {
    return new StateBuilder<IPurposeState>(state, action).toLoaded().build();
  })
);

export function purposeReducer(state: IPurposeState | undefined, action: Action) {
  return purposeReducerFn(state, action);
}
